import axios from "axios";
import { config } from "../shared/app.config";

const RESOURCE_NAME = "/app/popups";
const RESOURCE_NAME_PUBLIC = "/webadmin/public/pop-ups";

export default {
  getAllPopUps(restaurant_id) {
    return axios.post(`${config.webApiBase + RESOURCE_NAME}/all`, {
      restaurant_id,
      active: false,
    });
  },

  getOne(id) {
    return axios.get(`${config.webApiBase + RESOURCE_NAME}/one/${id}`);
  },

  create(popUp) {
    const requestConfig = {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    };
    return axios.post(
      `${config.webApiBase + RESOURCE_NAME}/create`,
      popUp,
      requestConfig
    );
  },

  edit(id, popUp) {
    const requestConfig = {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    };

    return axios.post(
      `${config.webApiBase + RESOURCE_NAME}/update/${id}`,
      popUp,
      requestConfig
    );
  },

  delete(id) {
    return axios.get(`${config.webApiBase + RESOURCE_NAME}/remove/${id}`);
  },

  active(id) {
    return axios.get(`${config.webApiBase + RESOURCE_NAME}/active/${id}`);
  },

  deactive(id) {
    return axios.get(`${config.webApiBase + RESOURCE_NAME}/disable/${id}`);
  },
};
